import { API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./httpClient";

export const getAllVacancies = async ({ page, size, search, location, category, yearsOfExperience, jobType, timePeriod }) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);

  if (search) params.append("searchQuery", search);
  if (location) params.append("location", location);
  if (category) params.append("jobCategoryId", category);
  if (jobType) params.append("jobType", jobType);
  if (yearsOfExperience) params.append("yearsOfExperience", yearsOfExperience);
  if (timePeriod) params.append("timePeriod", timePeriod);

  if (!API_ENDPOINTS?.VACANCIES) {
    throw new Error("Endpoint de vagas não configurado");
  }

  return apiRequest(
    `${API_ENDPOINTS.VACANCIES}?${params.toString()}&sort=createdAt,desc`,
    {
      fallbackMessage: "Erro ao buscar vagas",
      errorCode: "VACANCY_LIST_FAILED",
    }
  );
};

export const getSimilarVacancies = async (id) => {
  if (!API_ENDPOINTS?.VACANCIES) {
    throw new Error("Endpoint de vagas não configurado");
  }

  return apiRequest(`${API_ENDPOINTS.VACANCIES}/similar/${id}`, {
    fallbackMessage: "Erro ao buscar vagas",
    errorCode: "SIMILAR_VACANCIES_FAILED",
  });
};

export const getJobCategories = async () => {
  if (!API_ENDPOINTS?.VACANCIES) {
    throw new Error("Endpoint de vagas não configurado");
  }

  return apiRequest(`${API_ENDPOINTS.VACANCIES}/categories`, {
    fallbackMessage: "Erro ao buscar categorias",
    errorCode: "VACANCY_CATEGORIES_FAILED",
  });
}

export const getVacancyById = async (vacancyId) => {
  return apiRequest(`${API_ENDPOINTS.VACANCIES}/${vacancyId}`, {
    fallbackMessage: `Failed to fetch vacancy with ID: ${vacancyId}`,
    errorCode: "VACANCY_FETCH_FAILED",
  });
};
